// extracted by mini-css-extract-plugin
export var anchor = "LinkNoStyle-module--anchor--fc6be";
export var linkoverride = "LinkNoStyle-module--linkoverride--1dd0f";